module.exports = __webpack_public_path__ + "img/未标题-3-02.2ff334f3.png";